import Input from 'components/Input'
import { InputFieldTypes } from 'components/Input/types'
import { AddSelectedFiltersFunctionType } from 'core/multiple-search/redux/types'
import React, { useEffect, useState } from 'react'
import { FieldDataType } from './field-component'

type MultiselectWrapperProps = {
  id: string
  fieldData: FieldDataType
  addSelectedFilters: AddSelectedFiltersFunctionType
}

function getNormalizedOptions(id: string, listValues: Array<string>) {
  if (id === 'accordion.dvr') {
    return listValues.map(dvrStatus => ({ label: `dvr.label_status_${dvrStatus}`, value: dvrStatus }))
  }

  return []
}

export default function MultiselectWrapper({id, fieldData, addSelectedFilters}: MultiselectWrapperProps) {
  const [selected, setSelected] = useState(fieldData.currentValue)

  useEffect(() => {
    addSelectedFilters(id, selected, fieldData.name, 'multiselect')
  }, [selected.length])

  useEffect(() => {
    setSelected(fieldData.currentValue || [])
  }, [fieldData.currentValue.length])

  return (
    <Input
      type={InputFieldTypes.multiselect}
      value={selected}
      setValue={setSelected}
      options={getNormalizedOptions(id, fieldData.listValues)}
      labelParams={{ 
        i18nTag: fieldData.dateKey || ''
       }}
    />
  )
}
